import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Sensor } from '../components/Sensor';
import { useAppDispatch, useAppSelector } from '../hooks';
import { subscribeEntities } from '../reducers/entitiesSlice';
import { selectSensors } from '../reducers/SelectSensors';
export const Sensors = (_props) => {
    const dispatch = useAppDispatch();
    const sensors = useAppSelector(selectSensors);
    const entitiesToSubscribe = [];
    function subscribe(v) { if (v != undefined) {
        entitiesToSubscribe.push(v);
    } }
    for (const s of sensors) {
        subscribe(s.temp);
        subscribe(s.humid);
    }
    useEffect(() => subscribeEntities(dispatch, entitiesToSubscribe), [entitiesToSubscribe]);
    const sensorElems = [];
    for (const s of sensors) {
        sensorElems.push(_jsx(Sensor, { device: s.device, temp: s.temp, humid: s.humid }, s.device.id));
    }
    return (_jsx("div", { className: "page-container", children: _jsx("div", { className: "sensors", children: sensorElems }) }));
};
